import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployerRoutingModule } from './employer-routing.module';
import { EmployerModuleComponent } from './employer.module.component';
import { EmployerLibraryModule, MaterialLibraryModule } from 'epay-library';
import { HelperLibraryModule } from 'epay-library';
import { CommonLibraryModule } from 'epay-library';
import { BaseLayoutModule } from '../layout/base-layout.module';

import { EMPCreditCardLandingComponent } from './components/creditcard/landing/creditcard.landing.component';
import { EMPCreditCardPaymentComponent } from './components/creditcard/payment/creditcard.payment.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { MaskDataPipe } from 'epay-library';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ngxInputRegulateModule } from 'ngx-input-regulate';

@NgModule({
  declarations: [
    EmployerModuleComponent,
    EMPCreditCardPaymentComponent,
    EMPCreditCardLandingComponent,
  ],
  imports: [
    CommonModule,
    EmployerRoutingModule,
    EmployerLibraryModule,
    HelperLibraryModule,
    CommonLibraryModule,
    BaseLayoutModule,
    MatFormFieldModule,
    MaterialLibraryModule,
    ReactiveFormsModule,
    FormsModule,
    ngxInputRegulateModule,
    MatCardModule,
    MatTabsModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [MaskDataPipe],
})
export class EmployerModule {}
